
import React, { useState, useEffect } from 'react';
import getEncodedImageUrl from "../helpers/get-encoded-image";
import Slider from "react-slick";


interface ImStatelessProps {
    sliderRef: any;
    singleVersion: any;
    seekVideo?: any;
    currentThumbnail: any;
    enableRender: any;
    videoRef?: any;
    webcamRef?: any;
}

const SliderCustom = React.memo<ImStatelessProps>(({ sliderRef,
    singleVersion,
    seekVideo,
    currentThumbnail,
    enableRender, videoRef, webcamRef }) => {


    const [currentIndex, setCurrentIndex] = useState(currentThumbnail);

    useEffect(() => {
        setCurrentIndex(currentThumbnail);

        console.log("Player Index Custum " + currentThumbnail);
    }, [currentThumbnail]);

    // next arrow UI components
    const SampleNextArrow = React.memo((props: any) => {
        const { className, style, onClick } = props;
        return (
            <div className={className} style={{ ...style }} onClick={onClick}>
                <img src="/icons/arrow-right.svg" alt="next" />
            </div>
        )
    })
    // previous arrow UI components
    const SamplePrevArrow = React.memo((props: any) => {
        const { className, style, onClick } = props;
        return (
            <div className={className} style={{ ...style }} onClick={onClick}>
                <img src="/icons/arrow-left.svg" alt="next" />
            </div>
        )
    })
    // Slider component configuration
    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 1,
        arrows: true,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />
    };


    // only renders if url have changed!
    return (
        <Slider
            ref={sliderRef}
            className="slides-slider d-none d-lg-block"
            {...settings}
        >
            {singleVersion.thumbnails &&
                singleVersion.thumbnails
                    .sort((a: any, b: any) => a.time - b.time)
                    .map((thumbnail: any, index: any) => (
                        <a
                            key={thumbnail.time}
                            data-time={thumbnail.time}
                            href="/"
                            onClick={(e) => {
                                e.preventDefault();
                                seekVideo(thumbnail.time / 1000, videoRef, webcamRef);
                                setCurrentIndex(index);
                                currentThumbnail = index;
                                sliderRef.current.slickGoTo(index);
                            }}

                            className={`item ${currentIndex === index ? "active-slide" : ""
                                }`}
                        >
                            <div className="ml-10">
                                <img
                                    className="img-fluid"
                                    src={getEncodedImageUrl(
                                        thumbnail.id.indexOf(
                                            "e-slides.net"
                                        ) > -1
                                            ? thumbnail.id.split(
                                                "e-slides.net/"
                                            )[1]
                                            : thumbnail.id,
                                        190,
                                        101
                                    )}
                                    alt={`Slide ${index + 1}`}
                                />
                            </div>
                        </a>
                    ))}
        </Slider>
    )
});

export default SliderCustom;
